import { AddressMinimap } from "@mapbox/search-js-react"
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography,
    useMediaQuery,
} from "@material-ui/core"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos"
import PlaceIcon from "@material-ui/icons/Place"
import { useContext, useEffect, useState } from "react"
import useAlert from "../../contexts/AlertContext"
import useEndereco from "../../contexts/EnderecoContext"
import useParametros from "../../contexts/ParametrosContext"
import SiteContext from "../../contexts/SiteContext"
import { useTextos } from "../../contexts/TextosContext"
import api from "../../services/api"
import { ComumCep, RegistrarLogErro } from "../../services/functions"

const useStyles = makeStyles(theme => ({
    dialogContent: {
        textAlign: "center",
    },
    contentContainer: {
        width: "80%",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        alignItems: "center",
        justifyContent: "center",
        margin: "2rem auto 0 auto",
        [theme.breakpoints.down("sm")]: {
            width: "85%",
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
        },
    },
    mapContainer: {
        width: "100%",
        aspectRatio: "16/7",
        overflow: "hidden",
        "& > div": { height: "100%" },
        [theme.breakpoints.down("sm")]: {
            aspectRatio: "2/1",
        },
        [theme.breakpoints.down("xs")]: {
            aspectRatio: "4/3",
        },
    },
    googleMapsContainer: {
        width: "100%",
        aspectRatio: "12/5",
        "& > div": { height: "100%" },
        [theme.breakpoints.down("sm")]: {
            aspectRatio: "2/1",
        },
        [theme.breakpoints.down("xs")]: {
            aspectRatio: "4/3",
        },
    },
    buttonContainer: {
        display: "flex",
        width: "100%",
        gap: "clamp(0.5rem, 5%, 1rem)",
        "& > button": {
            flex: 1,
        },
        [theme.breakpoints.down("xs")]: {
            flexDirection: "column-reverse",
        },
    },
    confirmarButton: {
        backgroundColor: `#28a745`,
        color: "white",
        "&:hover": {
            backgroundColor: "#28a745",
            filter: "brightness(1.05)",
        },
    },
    featureOptionList: {
        marginBottom: "1rem",
        "& svg": { marginRight: "0.5rem" },
        "& > div > div": {
            overflow: "hidden",
        },
    },
    featureOption: {
        display: "flex",
        gap: "0.5rem",
        alignItems: "center",
        fontSize: "1rem",
        "& > svg": {
            fontSize: "1.5rem",
        },
    },
}))

// TODO: Remover
const keyMapBox =
    "pk.eyJ1IjoiY2xpZW50ZWZpZWwiLCJhIjoiY2xzbmFrMjNiMDI1dDJpbnNvdm00enQ3aiJ9.gj6zNfUXE5F-SkpKDh-Ing"

const DialogConfirmationMapBox = props => {
    const classes = useStyles()
    const textos = useTextos()

    return (
        <Dialog
            open={props.openConfirmationMap}
            onClose={props.handleCloseConfirmationMap}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                <IconButton className="setaVoltarModal" onClick={props.handleCloseConfirmationMap}>
                    <ArrowForwardIosIcon />
                </IconButton>
                {textos.confirmarEndereco}
            </DialogTitle>
            <DialogContent style={{ padding: "1rem" }}>
                {props.selectedFeature && (
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Opções de Endereço</InputLabel>
                        <Select
                            value={props.selectedFeature}
                            onChange={props.handleChangeFeature}
                            className={classes.featureOptionList}
                            label="Opções de Endereço"
                        >
                            {props.featureOptions.map(feature => (
                                <MenuItem divider value={feature} className={classes.featureOption}>
                                    <PlaceIcon />
                                    {feature.place_name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}
                <div className={classes.mapContainer}>
                    <AddressMinimap
                        show={props.openConfirmationMap}
                        canAdjustMarker={true}
                        feature={props.selectedFeature}
                        onSaveMarkerLocation={props.handleSaveMarkerLocation}
                        accessToken={keyMapBox}
                    />
                </div>
            </DialogContent>
            <DialogActions>
                <div className={classes.buttonContainer}>
                    <Button variant="contained" onClick={props.handleCloseConfirmationMap}>
                        {textos.cancelar}
                    </Button>
                    <Button
                        className={classes.confirmarButton}
                        variant="contained"
                        onClick={props.checarCepMapBox}
                    >
                        {textos.confirmar}
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    )
}

export default function DialogMapBox({ DialogConfirmacaoinformacoes = () => {} }) {
    const {
        aplicativoDados,

        carrinho,

        estabelecimentoAtual,

        setLoading,
    } = useContext(SiteContext)

    const classes = useStyles()
    const parametros = useParametros()
    const textos = useTextos()
    const alertStart = useAlert()

    const {
        setNovoEndereco,
        selecionarRetiradaNoLocal,

        permiteRetiradaNoLocal,
        abrirMapBox,

        abrirCadastroEndereco,
        fecharCadastroCEP,
        fecharCadastroMapBox,
    } = useEndereco()

    const usarMapBoxAPI = aplicativoDados.tipoSelecaoEndereco === 2
    if (abrirMapBox && !usarMapBoxAPI) throw new Error("Map Box opened without system parameter")

    const [addressInputText, setAddressInputText] = useState("")
    const [selectedFeature, setSelectedFeature] = useState("")
    const [featureOptions, setFeatureOptions] = useState([])

    useEffect(() => {
        if (!abrirMapBox) setAddressInputText("")
    }, [abrirMapBox])

    const handleChangeFeature = e => setSelectedFeature(e.target.value)

    const [openConfirmationMap, setOpenConfirmationMap] = useState(false)
    const handleCloseConfirmationMap = () => setOpenConfirmationMap(false)

    const handleAddressSearch = e => setAddressInputText(e.target.value)

    const handleRetrieve = async () => {
        try {
            const temCoordenada =
                Number(estabelecimentoAtual.latitude) && Number(estabelecimentoAtual.longitude)

            const mapCenter = temCoordenada
                ? {
                      lat: Number(estabelecimentoAtual.latitude),
                      lng: Number(estabelecimentoAtual.longitude),
                  }
                : null

            const codigoPais = parametros.PUBLIC_CODIGO_PAIS ?? "br"
            const codigoLingua = parametros.PUBLIC_CODIGO_LINGUA ?? "pt"

            let searchString = `https://api.mapbox.com/geocoding/v5/mapbox.places/${addressInputText}.json?access_token=${keyMapBox}&country=${codigoPais.toUpperCase()}&language=${codigoLingua}`

            if (mapCenter) {
                const minLng = mapCenter.lng - 0.15
                const minLat = mapCenter.lat - 0.12
                const maxLng = mapCenter.lng + 0.15
                const maxLat = mapCenter.lat + 0.12

                searchString = searchString
                    .concat(`&proximity=${mapCenter.lng},${mapCenter.lat}`)
                    .concat(`&bbox=${minLng},${minLat},${maxLng},${maxLat}`)
            }

            const res = await api.get(searchString)

            const features = res.data.features

            if (!features.length) {
                alertStart(textos.alertas.nenhumResultadoEndereco, "warning")
                return
            }

            setFeatureOptions(res.data.features)
            const feature = res.data.features[0]
            setSelectedFeature(feature)
            setOpenConfirmationMap(true)

            const fullAddress = feature.place_name.replace("Brazil", "Brasil")
            setAddressInputText(fullAddress)
        } catch (error) {
            console.error()
            RegistrarLogErro(error, "handleRetrieve")
        }
    }

    const handleSaveMarkerLocation = coordinates =>
        setSelectedFeature(prev => ({
            ...prev,
            geometry: {
                ...prev.geometry,
                coordinates,
            },
        }))

    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"))

    const checarCepMapBox = async () => {
        try {
            let valorCep = selectedFeature.context
                .find(ac => ac.id.includes("postcode"))
                ?.text.replace(/-/g, "")
                .replace(/ /g, "")
                .replace(/\//g, "")

            if (valorCep?.length === 8) {
                setLoading(true)
                const response = await ComumCep(valorCep, aplicativoDados)

                if (response.retornoErro) {
                    setLoading(false)
                    alertStart(response.mensagem, "error")
                    return
                }

                if (response.bairroEspecifico || response.bairros?.length >= 1) {
                    setNovoEndereco({
                        ...response,
                        bairroEspecifico: true,
                        cep: valorCep,
                        logradouro: selectedFeature.text,
                        numero: selectedFeature.address,
                        localidade: selectedFeature.context.find(ac => ac.id.includes("place"))
                            ?.text,
                        uf: selectedFeature.context
                            .find(ac => ac.id.includes("region"))
                            ?.short_code?.split("-")[1],
                        latitude: selectedFeature.center[1].toFixed(7),
                        longitude: selectedFeature.center[0].toFixed(7),
                    })
                } else if (response.id || response.logradouro) {
                    response.numero = selectedFeature.address
                    setNovoEndereco({
                        ...response,
                        bairroEspecifico: false,
                        logradouro: selectedFeature.text,
                        latitude: selectedFeature.center[1].toFixed(7),
                        longitude: selectedFeature.center[0].toFixed(7),
                    })
                } else {
                    alertStart("Não foi possível identificar seu CEP", "error")
                }
            } else {
                setNovoEndereco({
                    bairroEspecifico: aplicativoDados.tipoEntregaBairro === 1,
                    cep: valorCep,
                    logradouro: selectedFeature.text,
                    numero: selectedFeature.address,
                    bairro: selectedFeature.context.find(ac => ac.id.includes("neighborhood"))
                        ?.text,
                    localidade: selectedFeature.context.find(ac => ac.id.includes("place"))?.text,
                    uf: selectedFeature.context
                        .find(ac => ac.id.includes("region"))
                        ?.short_code?.split("-")[1],
                    latitude: selectedFeature.center[1].toFixed(7),
                    longitude: selectedFeature.center[0].toFixed(7),
                })
            }
            abrirCadastroEndereco()
            fecharCadastroCEP()
            handleCloseConfirmationMap()
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "checarCepMapBox", selectedFeature)
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
            setLoading(false)
        }
    }

    const handleClose = () => {
        fecharCadastroMapBox()
    }

    const handleRetiradaNoLocal = () => {
        selecionarRetiradaNoLocal()

        if (carrinho.pedido?.itens?.length) {
            DialogConfirmacaoinformacoes(true)
        }
    }

    const handleSubmit = e => {
        e.preventDefault()
        handleRetrieve()
    }

    return (
        <>
            <Dialog
                open={abrirMapBox}
                aria-labelledby="cep-title"
                fullWidth={true}
                maxWidth="sm"
                onClose={handleClose}
            >
                {!fullScreen ? <img src={aplicativoDados.urlLogo} className="imgModal" /> : null}

                <DialogTitle id="cep-title">
                    <IconButton className="setaVoltarModal" onClick={handleClose}>
                        <ArrowForwardIosIcon />
                    </IconButton>
                    {textos.adicionarEndereco}
                </DialogTitle>

                <form onSubmit={handleSubmit}>
                    <DialogContent className={classes.dialogContent}>
                        <Typography gutterBottom align="center" variant="h5" component="p">
                            {textos.digiteEndereco}
                        </Typography>
                        <div className={classes.contentContainer}>
                            <TextField
                                value={addressInputText}
                                onChange={handleAddressSearch}
                                autoFocus
                                fullWidth
                                variant="outlined"
                                placeholder={textos.digiteEndereco}
                                helperText={textos.enderecoHelperText}
                            />
                            <div className={classes.buttonContainer}>
                                {permiteRetiradaNoLocal ? (
                                    <Button
                                        size="small"
                                        variant="contained"
                                        onClick={handleRetiradaNoLocal}
                                    >
                                        {textos.retirarNoLocal}
                                    </Button>
                                ) : null}
                                <Button
                                    size="small"
                                    type="submit"
                                    className={classes.confirmarButton}
                                    variant="contained"
                                    disabled={!addressInputText}
                                >
                                    {textos.continuar}
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </form>
            </Dialog>
            <DialogConfirmationMapBox
                openConfirmationMap={openConfirmationMap}
                handleCloseConfirmationMap={handleCloseConfirmationMap}
                featureOptions={featureOptions}
                selectedFeature={selectedFeature}
                handleChangeFeature={handleChangeFeature}
                handleSaveMarkerLocation={handleSaveMarkerLocation}
                checarCepMapBox={checarCepMapBox}
            />
        </>
    )
}
